module.exports = __webpack_public_path__ + "4cb5c353c111e757e27b9bcde2e71c1b.svg";